import * as React from "react";
import classnames from "classnames";
import { RadioButton } from "@grandvisionhq/common";
import { FormContext } from "../../Form/Form/Form.js";
/* empty css                  */
const _RadioButtons = class _RadioButtons extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      name: this.props.scope,
      value: this.props.initialValue,
      required: !!this.props.initialValue === false,
      isTouched: false
    };
    this.handleChange = (event) => {
      const value = event.currentTarget.value;
      const updatedState = {
        ...this.state,
        value
      };
      this.setState(updatedState);
      this.props.onChange && this.props.onChange(updatedState);
    };
  }
  componentDidUpdate(prevProps) {
    const previousValue = prevProps.initialValue && prevProps.initialValue;
    const value = this.props.initialValue;
    if (value !== previousValue) {
      this.setState({
        value
      });
    }
  }
  componentDidMount() {
    this.props.onChange && this.props.onChange(this.state);
  }
  render() {
    const { items, scope, alignment, className, formName, ...rest } = this.props;
    const directionClass = alignment === "horizontal" ? "radio-buttons--horizontal" : "radio-buttons--vertical";
    return /* @__PURE__ */ React.createElement(
      "fieldset",
      {
        "data-t": rest["data-t"],
        className: classnames("radio-buttons", directionClass, className)
      },
      items && items.length > 0 && items.map((item, i) => {
        const inputId = `${formName || "radio-buttons"}_${item.value.toString().replace(/\s/g, "-") || i}`;
        return /* @__PURE__ */ React.createElement(
          RadioButton,
          {
            key: item.value,
            id: inputId,
            name: scope,
            variant: "plain",
            value: String(item.value),
            isChecked: item.value === this.state.value,
            "aria-checked": item.value === this.state.value,
            disabled: item.disabled,
            onChange: this.handleChange
          },
          item.label
        );
      })
    );
  }
};
_RadioButtons.defaultProps = {
  items: [],
  alignment: "horizontal",
  formName: ""
};
let RadioButtons = _RadioButtons;
const ConnectedRadioButtons = ({
  onChange,
  scope,
  ...rest
}) => /* @__PURE__ */ React.createElement(FormContext.Consumer, null, (context = {}) => {
  let value = rest.initialValue || "";
  if (context.getInitialState && scope) {
    const fieldState = context.getInitialState(scope);
    if (fieldState) {
      value = fieldState.value;
    }
  }
  return /* @__PURE__ */ React.createElement(
    RadioButtons,
    {
      ...rest,
      scope,
      formName: context.name,
      onChange: context.onChange || onChange,
      initialValue: value || rest.initialValue && rest.initialValue
    }
  );
});
ConnectedRadioButtons.defaultProps = {
  ...RadioButtons.defaultProps
};
export {
  RadioButtons,
  ConnectedRadioButtons as default
};
//# sourceMappingURL=RadioButtons.js.map
